export default "__VITE_ASSET__C82$kJGj__"